import type { DiagramFileInfoProps } from './types';

export const DiagramFileInfo = ({
  name,
  onNameChange,
}: DiagramFileInfoProps) => {
  const inputClass =
    'bg-[#0d1117] border border-[#30363d] text-[#c9d1d9] px-2.5 py-2 rounded-md text-sm font-mono w-full focus:outline-none focus:border-[#58a6ff]';

  return (
    <div className="bg-[#0d1117] border border-[#30363d] rounded-md p-3 mb-3">
      <h3 className="text-sm text-[#c9d1d9] font-semibold mb-2">
        Distribution Board File
      </h3>
      <div className="flex gap-3 flex-wrap">
        <div className="flex-1 min-w-[180px]">
          <label className="block text-[12px] text-[#8b949e] mb-1">
            Name
          </label>
          <input
            type="text"
            className={inputClass}
            value={name}
            onChange={(e) => onNameChange(e.target.value)}
            placeholder="e.g. distribution-board-1"
          />
        </div>
      </div>
    </div>
  );
};
